var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    fill: "white",
    stroke: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6925_8894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 38,
    height: 38
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 38,
    height: 38,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6925_8894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4232 44.6667L16.167 42.45L22.6587 35.9583C23.4767 35.1403 24.0372 34.1174 24.3402 32.8898C24.6442 31.6633 24.7962 29.7833 24.7962 27.25C24.7962 25.7194 25.1392 24.2153 25.8253 22.7375C26.5114 21.2597 27.4878 19.8875 28.7545 18.6208C31.1559 16.2194 33.808 14.8604 36.7107 14.5437C39.6135 14.2271 42.0017 15.0319 43.8753 16.9583C45.7753 18.8583 46.567 21.2597 46.2503 24.1625C45.9337 27.0653 44.5878 29.7042 42.2128 32.0792C40.9462 33.3458 39.5739 34.3222 38.0962 35.0083C36.6184 35.6944 35.1142 36.0375 33.5837 36.0375C31.0239 36.0375 29.1503 36.1826 27.9628 36.4729C26.7753 36.7632 25.7594 37.3305 24.9149 38.175L18.4232 44.6667ZM29.3087 31.4458C30.5489 32.6597 32.2246 33.1083 34.3357 32.7917C36.4469 32.475 38.3337 31.4854 39.9962 29.8229C41.685 28.134 42.6947 26.2404 43.0251 24.1419C43.3544 22.0445 42.8989 20.4021 41.6587 19.2146C40.392 17.9479 38.7364 17.4729 36.6917 17.7896C34.6461 18.1062 32.7656 19.109 31.0503 20.7979C29.3878 22.4604 28.3787 24.3409 28.023 26.4393C27.6662 28.5367 28.0948 30.2055 29.3087 31.4458ZM41.5003 49.4167C39.7587 49.4167 38.2677 48.7965 37.0274 47.5562C35.7871 46.316 35.167 44.825 35.167 43.0833C35.167 41.3417 35.7871 39.8507 37.0274 38.6104C38.2677 37.3701 39.7587 36.75 41.5003 36.75C43.242 36.75 44.733 37.3701 45.9732 38.6104C47.2135 39.8507 47.8337 41.3417 47.8337 43.0833C47.8337 44.825 47.2135 46.316 45.9732 47.5562C44.733 48.7965 43.242 49.4167 41.5003 49.4167ZM41.5003 46.25C42.3712 46.25 43.1169 45.9402 43.7376 45.3206C44.3572 44.6999 44.667 43.9542 44.667 43.0833C44.667 42.2125 44.3572 41.4667 43.7376 40.8461C43.1169 40.2265 42.3712 39.9167 41.5003 39.9167C40.6295 39.9167 39.8837 40.2265 39.2631 40.8461C38.6435 41.4667 38.3337 42.2125 38.3337 43.0833C38.3337 43.9542 38.6435 44.6999 39.2631 45.3206C39.8837 45.9402 40.6295 46.25 41.5003 46.25Z",
    fill: "#002953"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/tennis.321e03fbdcda991ca9c8ca0b7ed0d6cd.svg";
export { ForwardRef as ReactComponent };